/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLayoutAlignCenterFilled = createReactComponent("filled", "layout-align-center-filled", "IconLayoutAlignCenterFilled", [["path", { "d": "M12 3a1 1 0 0 1 1 1v4h3a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-3v4a1 1 0 0 1 -2 0v-4h-3a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3h3v-4a1 1 0 0 1 1 -1", "key": "svg-0" }]]);

export { IconLayoutAlignCenterFilled as default };
//# sourceMappingURL=IconLayoutAlignCenterFilled.mjs.map
